import { Grid, Container } from '@mui/material';
import TopNavLinks from './TopNavLinks';

/**
 * @name TopNavContainer
 * @description TopNav Container
 * @param {object} root0  - destructured object
 * @param {object} root0.navCmsHeaderData  - Header data from strapi
 * @returns {JSX.Element} JSX.Element
 */
const TopNavContainer = ({ navCmsHeaderData }) => (
  <Container>
    <Grid
      container
      justifyContent={{ xs: 'flex-end', sm: 'flex-end', md: 'space-between' }}
      alignItems='center'
    >
      <Grid item sm='auto' sx={{ display: { xs: 'none', md: 'unset' } }}>
        <TopNavLinks links={navCmsHeaderData} leftLink />
      </Grid>
      <Grid item sm='auto'>
        <TopNavLinks links={navCmsHeaderData} />
      </Grid>
    </Grid>
  </Container>
);

TopNavContainer.displayName = 'TopNavContainer';
export default TopNavContainer;
